import { Store } from '@ngrx/store';
import { Component, OnInit } from '@angular/core';
import { AppState } from '../appState/appStateStore.module';
import 'rxjs/add/operator/take';
import { Router } from '@angular/router';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.css']
})
export class ErrorComponent implements OnInit {
  error: any;

  constructor(private router: Router, private store: Store<AppState>) { }

  ngOnInit() {
    this.store.take(1).subscribe(s => this.error = s.app.error);
  }

  onForward() {
    this.router.navigate(['/' + this.error.forwardLink]);
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/error/error.component.ts